import { EventHeartbeatState } from './types';
import { EventState } from '../event/types';

import { getBrowserSpecs } from '@/services/browser.service';

const mutations = {
  setHeartbeatIntervalId(state: EventHeartbeatState, timeoutId: number | null) {
    state.heartbeatIntervalId = timeoutId;
  },
  stopEventHeartbeat(state: EventHeartbeatState) {
    const heartbeatIntervalId = state.heartbeatIntervalId;
    if (heartbeatIntervalId) {
      clearInterval(heartbeatIntervalId);
    }
    state.heartbeatIntervalId = null;
  },
  setHeartbeatMetadata(state: EventHeartbeatState, payload: Partial<EventHeartbeatState['metadata']>) {
    state.metadata = { ...state.metadata, ...payload };
  },
  setHeartbeatEventInfo(state: EventHeartbeatState, event: EventState) {
    state.event_info = {
      event_id: event.event.id,
      event_type: event.event.event_type,
      is_hybrid: event.event.is_hybrid,
      is_available_on_demand: event.event.is_available_on_demand,
      on_demand_mode: event.event.on_demand_mode,
      org_id: event?.organization?.id ?? ''
    };
  },
  setHeartbeatUserData(state: EventHeartbeatState, payload: Partial<EventHeartbeatState['user_data']>) {
    state.user_data = {
      ...state.user_data,
      ...payload
    };
  },
  setHeartbeatCurrentScreenState(
    state: EventHeartbeatState,
    payload: Partial<EventHeartbeatState['current_screen_state']>
  ) {
    state.current_screen_state = {
      ...state.current_screen_state,
      ...payload
    };
  },
  setHeartbeatQos(state: EventHeartbeatState, payload: Partial<EventHeartbeatState['qos']>) {
    state.qos = {
      ...state.qos,
      ...payload
    };
  },
  setHeartbeatClientDeviceInfo(state: EventHeartbeatState) {
    const browserSpecs = getBrowserSpecs();

    state.device = {
      ...state.device,
      is_mobile: window.mobileCheck && window.mobileCheck(),
      browser: browserSpecs.name,
      browser_version: browserSpecs.version,
      os: window.navigator.platform,
      screen_height: window.screen.height,
      screen_width: window.screen.width,
      cores: window.navigator.hardwareConcurrency
    };
  }
};

export default mutations;
export type EventHeartbeatMutations = typeof mutations;
